export default {
  message: {
    hello: 'hello world'
  },
  // 顶部
  header: {
    balance: 'Balance',
    viewDetails: 'View details',
    logout: 'Log Out'
  },
  common: {
    close: 'Close',
    search: 'Search',
    action: 'Action',
    edit: 'Edit',
    delete: 'Delete',
    save: 'Save',
    form_blank: 'It cannot be blank',
    delete_remind: 'Are you sure to delete?',
    no_data: 'No Data'
  },
  // 首页
  homeRoute: {
    title: 'Home'
  },
  home: {
    edit: 'Edit',
    balance: 'Balance:',
    recharge: 'Recharge',
    credit_line: 'Credit Line:',
    address: 'Address',
    receiver: 'Receiver',
    address_unit: 'piece',
    manage: 'Manage',
    shipper: 'Shipper',
    unpaid_order: 'Unpaid Order',
    suggest_recharge: 'Suggest Recharge',
    freight: 'Freight',
    tax: 'Tax',
    not_billed_order: 'Not Billed Order(single)',
    detail: 'Detail',
    single: 'single',
    unpaid_bill: 'Unpaid Bill(single)',
    notice_freight: 'Freight Charge:',
    notice_tax: 'Tax:',
    notice_title1: 'Insufficient fund.You have',
    notice_title2: 'orders',
    notice_title3: 'entered warehouse.',
    notice_title4: 'orders on the road to warehouse.',
    notice_result1: '',
    notice_suggest_recharge: 'Suggest to recharge',
    notice_notice_result2: ',or more to ensure shipping in time.',
    waiting_for_shipping: 'waiting for shipping',
    notice_recharge: 'Recharge',
    address_title_receiver: 'Receiver',
    address_title_shipper: 'Shipper',
    address_placeholder: 'Please enter name/tel',
    address_add: 'Add',
    address_edit: 'Edit',
    address_name: 'Name',
    address_company: 'Company',
    address_tel: 'Tel',
    address_address: 'Address',
    address_tel_message: 'please enter number',
    all_order: 'All Order:',
    order_piece: 'order',
    sign: 'Sign:',
    creat_order: 'Create Order',
    order_center: 'Order Center',
    import_order: 'Import Order',
    order_no: 'Order:',
    order_receiver: 'Receiver:',
    order_station: 'Order Station',
    singed_aging: 'Singed Aging',
    month_statistics: 'Statistics of monthly signed in documents',
    date_placeholder: 'Please select a date',
    normal_singed: 'Normal Singed',
    signed_later: 'Signed Later',
    all_sign: 'sign',
    over_time_signed: 'Over Time Signed'
  },
  // 订单
  orderRoute: {
    orders: 'Orders',
    orderDetail: 'Order Detail',
    myOrders: 'Order Center',
    createOrder: 'Create Order',
    importOrder: 'Import Order',
    receiverTaxUnpaid: 'Receiver Tax Unpaid',
    senderTaxUnpaid: 'Pay Tax',
    priceList: 'Price List',
    remoteAreaOrders: 'Remote Area Orders'
  },
  // 财务
  finacialRoute: {
    finacialStats: 'Finacial Stats',
    incomingoutgoings: 'Income & Expense',
    freightstatistics: 'Cost Stats',
    bill: 'Customer Bill',
    billDetail: 'Customer Bill Detail'
  },
  incomingoutgoings: {
    title_1: 'List of Invoices',
    title_2: 'Invoice management ',
    Order_NO: 'Order NO',
    inputOrderNoReceiver: 'Please enter order No.',
    balance: 'Balance',
    amount: 'Amount',
    detail: 'Detail',
    storageDetail: 'Details of warehouse rental charges',
    totalVolume: 'Total volume(CBM)',
    volume: 'Volume(CBM)',
    fee: 'Fee(CNY)',
    productName: '品名',
    storageAge: '库龄',
    close: 'Close',
    orderDate: 'Order date',
    search: 'Search',
    tradeTypes: {
      allTradeType: 'All Transaction',
      recharge: 'Recharge',
      refund: 'Refund',
      compensation: 'Compensation',
      payFreight: 'Freight Charge',
      freightDifference: 'Freight Charge Shortage',
      returnDifference: 'Freight Charge Profit',
      returnCharges: 'Freight Charge Refund',
      secondDeliveryFee: 'Secondary Delivery Fee',
      payTaxes: 'Tax',
      specialClearanceFee: 'Clearance Charge for Special Items',
      prepaidTax: 'Advanced Tax Deduct',
      refundPrepaidTax: 'Advanced Tax Refund',
      returnDestructionFee: 'Destruction/Retun Goods Charge',
      overseasStorageCharge: 'Overseas Storage Charges',
      overseasWarehouseHandleFee: 'Overseas Operation Fee',
      overseasWarehouseHandleReturnFee: 'Return Overseas Operation Fee',
      overseasWareInBoundFee: 'Overseas Warehousing Fee',
      overseasWareInBoundReturnFee: 'Overseas Warehousing Fee Refund',
      bankServiceCharge: 'Bank Charges',
      remoteAreaCharge: 'remote area fee',
      other: 'Other'
    },

    Search: 'Search',
    Export: 'Export',

    label_1: 'Detail',
    label_2: 'Summary',

    Date: 'Date',
    Time: 'Time',
    Transaction_Type: 'Transaction Type',
    Reason: 'Remark',
    Recharge_Type: 'Recharge Type',
    Remark: 'Remark',
    Order_No: 'Order No',
    Customer_No: 'Reference',
    Number: 'Number',
    City: 'City',
    Postcode: 'Postcode',
    Suburb: 'Suburb',
    Zone: 'Zone',
    Weight: 'Final Weight(KG)',
    Amount: 'Amount(ZAR)',
    Balance: 'Balance(ZAR)',
    Declared: 'Declared Value',
    Action: 'Action',

    type_2: 'Transaction type',
    total: 'Total amount'
  },
  Customer_Bill: {
    title_1: 'Customer Bill',
    title_2: 'Financial Management',
    Billed: 'Billed',
    Unbilled: 'Unbilled',
    All_Paystatus: 'All Paystatus',
    Unpaid: 'Unpaid',
    Paid: 'Paid',
    Partpaid: 'Partpaid',
    Title: 'Title',
    Payment_status: 'Payment status',
    Quantity_of_order: 'Quantity of order',
    Bill_Amount: 'Bill Amount',
    Adjustment_amount: 'Adjustment amount',
    Confirmed_Amount: 'Confirmed Amount',
    Reason_for_Adjustment: 'Reason for Adjustment',
    Founder: 'Founder',
    Date: 'Date',
    Modified_by: 'Modified by',
    Modified_time: 'Modified time',
    Action: 'Action',
    Waybill_Details: 'Waybill Details',
    Overseas_Warehouse: 'Overseas Warehouse',
    button_1: 'Quantity of order',
    button_2: 'Freight',
    button_3: 'TAX',
    button_4: 'Others',
    button_5: 'Overseas Warehouse Operation Fee',
    button_6: 'Overseas Warehouse Storage Fee',
    Time: 'Time',
    Waybill_No: 'Waybill No',
    Customer_order_No: 'Customer order No',
    City: 'City',
    Post_Code: 'Post Code',
    Suburb: 'Suburb',
    Area: 'Area',
    chargeable_Weight: 'Chargeable Weight',
    total_Shipping: 'Total Shipping',
    total_Tax: 'Total Tax',
    other: 'Others (return/destruction fee)',
    type: 'Type',
    number_of_Parcels: 'Number of Parcels',
    weight: 'Weight(KG)',
    volume: 'Volume(CBM)',
    fee: 'Fee(CNY)',
    exportBillDetail: 'Export of order details',
    exportOverseasDetail: 'Export overseas warehouse details'
  },
  invoiceInfo: {
    title_1: 'Invoice Information Management',
    title_2: 'Invoice management',
    label_1: 'Invoice title :',
    label_2: 'Prescribing type :',
    label_3: 'invoice type :',
    label_4: 'Tax ID No.:',
    label_5: 'Deposit bank :',
    label_6: 'Account name :',
    label_7: 'Registered address :',
    label_8: 'Registered phone :',
    label_1_placeholder: 'Invoice',
    label_2_placeholder: 'Prescribing type',
    label_3_placeholder: 'invoice type',
    label_4_placeholder: 'Tax ID No.',
    label_5_placeholder: 'Deposit bank',
    label_6_placeholder: 'Account name',
    label_7_placeholder: 'Registered address',
    label_8_placeholder: 'Registered phone',
    save: 'Submit review',
    enterprise: 'Enterprise',
    auditing: 'Under Review',
    auditFailed: 'The invoice information was not approved',
    auditSuccess: 'Verified !',
    cannotBeNull: 'This cannot be left blank'
  },
  getInvoiceIndex: {
    title_1: 'Invoice request',
    title_2: 'Invoice management',
    type: 'Type',
    amount: 'Amount (CNY)',
    operation_Date: 'Operation date',
    total: 'Total :',
    totalAmount: 'Total amount',
    button: 'Ask for invoice',
    checkRecords: 'Please tick record!',
    invoiceInfoConfirm: 'Invoicing information confirmation!',
    invoiceTitle: 'Invoice',
    doInvoiceType: 'Prescribing type',
    invoiceType: 'Invoice type',
    vatSpecialInvoice: 'Vat special invoice',
    valueAddedTaxInvoice: 'Value added tax invoice',
    invoiceAmount: 'Invoice amount',
    taxPayment: 'Tax',
    taxRegistCertNo: 'Tax registration code',
    bankName: 'Deposit bank',
    accountNo: 'Account name',
    registeredAddress: 'Registered address',
    registeredTel: 'Registered phone',
    invoiceShippingAddress: 'Invoice shipping address',
    invoiceContact: 'Invoice contact',
    close: 'Close',
    submit: 'Submit',
    ok: 'Ok',
    enterprise: 'Enterprise',
    receiver: 'Please enter the receiver',
    receiverAddress: 'Please enter the receiver address'
  },
  // 用户
  userRoute: {
    personal: 'Personal Info',
    myProfile: 'My Profile',
    changePwd: 'Change Pwd',
    recharge: 'Recharge'
  },
  // 发票
  invoiceRoute: {
    invoiceManagement: 'Invoice Management',
    invoiceInformationManagement: 'Invoice Information Management',
    invoiceRequest: 'Invoice Request',
    invoiceList: 'List of invoices'
  },

  HOME: {
    all_orders: 'All Order',
    all_sign: 'Sign',
    create_order: 'Create Order',
    order_center: 'Order Center'
  },
  my_order: 'my order',
  page_pre: 'Previous',
  page_next: 'Next',
  REGISTER: {
    person_title: 'PERSONAL REGISTRATION',
    business_title: 'BUSINESS USER',
    business_triggle_sign: 'Business User?',
    person_confirm_submit: 'Confirm Registration',
    person_registration_intro: 'Confirm Registration means consent',
    protocol_name: '《Platform BUFFALO Terms of Use》',
    person_triggle_sign: 'Personal Registration?'
  },
  LOGIN: {
    login_title: 'LOGIN',
    login_btn: 'Login',
    welcome: 'Welcome to BUFFALO International',
    copyright: 'Copyright © buffaloex.com. All Rights Reserved',
    conditions: 'Conditions of Carriage',
    privacy_statement: 'Privacy Notice',
    use_terms: 'Prohibted&Restricted ltems',
    LOGIN_OPTION: 'LOGIN IN',
    SIGN_UP_OPTION: 'SIGN UP',
    USERNAME_PLACEHOLDER: 'Please enter User Name',
    PASSWORD_PLACEHOLDER: '8~20 digits including numbers and letters',
    FORGET_LINK: 'Forget password',
    USERNAME: 'User Name',
    PASSWORD: 'Password',
    HOME: 'Home',
    INTERNATIONAL: 'International'
  },
  FORGET: { SAVE: 'Save' },
  forget_password_link: 'FORGET PASSWORD',
  LABEL: {
    phone: 'Phone',
    phone_placeholder: 'Please enter Phone',
    phone_btn: 'Verification Code',
    code: 'Verification Code',
    code_placeholder: 'Verification code received in mobile',
    code_no_input: 'Please enter Verification code',
    password: 'Password',
    currency: 'Currency',
    currency_CNY: 'Chinese Yuan (CNY)',
    currency_ZAR: 'South African Rand (ZAR)',
    password_placeholder: '8~20 digits,including numbers and letters',
    password_input_wrong: 'Please enter 8~20 digits,including numbers and letters',
    password_original_no_input: 'Please enter original password',
    password_no_input: 'Please enter password',
    confirm_password: 'Confirm Password',
    confirm_password_placeholder: 'Enter the above password again',
    confirm_password_no_input: 'Please enter Confirm Password',
    password_input_different: 'The two passwords are inconsistent',
    user_name: 'User Name',
    user_name_placeholder: 'Please enter User Name',
    cellphone_wrong: 'Please enter correct Phone',
    send_success: 'Send Successfully!',
    register_success: 'Register Successfully',
    company_name: 'Company',
    company_name_placeholder: 'Please enter Company',
    company_name_alias: 'Company Abbreviation',
    company_name_alias_placeholder: 'Please enter Company Abbreviation',
    company_short_name_over_length: 'The company abbreviation cannot exceed 8 characters',
    contact_phone: 'Phone',
    contact_phone_placeholder: 'Please enter Phone',
    email: 'Email',
    email_placeholder: 'Please enter Email',
    email_input_wrong: 'Please enter correct Email',
    invite_code: 'Invitation code',
    invite_code_placeholder: 'Please contact BUFFALO commercial specialist',
    your_name: 'Your name',
    your_name_placeholder: 'Please enter Your Name',
    dynamic_pin: 'Dynamic PIN',
    dynamic_pin_placeholder: 'Please enter Dynamic PIN',
    login_fail: 'username or password is wrong',
    login_success: 'Login Successfully!',
    customer_helper: 'customer service',
    customer_confirm: '',
    main_city: 'major city',
    city: 'city',
    postcode: 'postal code',
    suburb: 'suburb',
    system_error: 'System Exception',
    address_placeholder: 'Please enter cityname or postcode or suburb',
    order_no_input: 'waybill number not empty！',
    sign_picture: 'Sign in picture',
    confirm_pay_process_start:
      'If you through a bank transaction paid the tax, and the order status is not processed, please click ',
    confirm_pay_process_end: 'to upload your proof of payment.',
    login_placeholder: 'User/Email/Phone'
  },
  SEO: {
    register: 'Register',
    forget: 'Forget Password',
    contact_us: 'Contact Us',
    login: 'Login',
    tracking: 'Tracking',
    service: 'Products',
    service_sea: 'International Sealine-  service',
    service_air: 'International Airline-  service',
    service_oversea: 'Oversea Location -  service',
    service_local: 'Domestic Dispatching -  service',
    about: 'About Us',
    help: 'Help',
    index_title:
      'BUFFALO Official website, BUFFALO South Africa green, BUFFALO South Africa Express, South Africa air express service, China sent to South Africa, South Africa International Express Line, South Africa green express, South Africa Express Service, South Africa delivery,South African green advantage, BUFFALO South Africa clearance,South Africa E-Business Parcels',
    index_description:
      'BUFFALO professional South African courier service providers, South Africa has a local area of 35,000 square meters of land, customs bonded warehouses 6,000 square meters, delivery vehicles 30, 50 distribution workers. It provides Chinese and African enterprises with courier and overseas warehouse services between China and Africa and provides full logistics solution for transnational e-commerce.',
    index_keywords:
      'BUFFALO, South Africa green,South Africa Express,South Africa clearance,South Africa delivery,South Africa International Express Line,South Africa green express,South African green advantage,China sent to South Africa,South Africa Express Service,South Africa E-Business Parcels'
  },
  index: 'index',
  Orders: 'Orders',
  Order_Center: 'Order Center',
  Create_Order: 'Create Order',
  'Import Order': 'Import Order',
  'Tax Unpaid': 'Tax Unpaid',
  'Price List': 'Price List',
  'Pay Tax': 'Pay Tax',
  'Remote Area Orders': 'Remote Area Orders',
  Finacial_Stats: 'Finacial Stats',
  'Income_&_Expense': 'Income & Expense',
  Cost_Stats: 'Cost Stats',
  Personal_info: 'Personal info',
  My_Profile: 'My Profile',
  Change_Pwd: 'Change Pwd',
  Recharge: 'Recharge',
  showTitle: 'Showing 0 to 0 of 0 entries',
  OrderCenter: {
    orderStatus: 'Order Status',
    order_title: 'Order Center',
    'left-title': 'Orders',
    create_time: 'Create Time',
    Warehouse_entry_Time: 'Inbound Time',
    form_info: 'Order No/Reference/Consignee',
    clear: 'Clear',
    searchContent: 'Search Content',
    search_btn: 'Search',
    print_btn: 'Print',
    export_btn: 'Export',
    edit_btn: 'Modify the declared value and weight',
    tab_1: 'All',
    tab_2: 'Unpaid&Inbound',
    tab_3: 'Shipping',
    tab_4: 'Finished',
    Status: 'Status',
    Order_No: 'Order No',
    Reference: 'Reference',
    Logistics: 'Logistics Type',
    Create_Time: 'Create Time',
    Warehousing_Time: 'Inbound Time',
    Signed_Time: 'Signed Time',
    Cosignee: 'Consignee',
    Destination: 'Destination',
    Box_No: 'Box No',
    Estimated_Weight: 'Estimated Weight',
    Actual_Weight: 'Actual Weight',
    no_data: 'No data available in table',
    Fright_Charge: 'Freight Charge',
    Tax: 'Estimated Tax',
    Total_Amount: 'Total Amount',
    notice: 'please choose Order NO',
    Tax_pay_status: 'Tax Pay Status',
    Tax_pay_status_No: 'Unpaid',
    Tax_pay_status_Yes: 'Paid'
  },
  CreateOrder: {
    uploadInvoice: 'Upload invoice',
    uploadPackingList: 'Upload Packing List',
    reUpload: 'Re-upload',
    uploadTips: 'Please upload a JPG/PNG/PDF file with a size of less than 10M',
    shipperNameTip:
      'The Shipper information will be filled in with the invoice. Please fill in carefully.',
    action: 'Action',
    title_1: 'Order',
    title_2: 'Orders',
    title_3: 'Create Order',
    General_Info: 'General Info',
    Logistics_type: 'Logistics Type',
    Logistics_type_placeholder: 'Please choose logistics type',
    Tax_Payer: 'Tax Payer',
    Storehouse: 'Storehouse*',
    Express_No: 'Express No (Custom No)',
    red_tips:
      'Please fill in the Express No. accurately to identify the package in BUFFALO warehouse',
    red_tips2: 'to identify the package in BUFFALO warehouse',
    yellow_tips: 'attention',
    yellow_tips_1:
      '1.Make sure that the actual shipping warehouse is consistent with the selected warehouse, otherwise warehouse can not finish receiving.',
    yellow_tips_2:
      "2.According to Chinese customs requirement, collecting at hangzhou must approve shipper's English name/ shipper's company Chinese name/shipper's company English name ,and the company must have export license.",
    Consignee_Info: "Consignee's Info",
    Contact: 'Frequent Contact',
    Consignee_Name: "Consignee's Name",
    Company_Name: 'Company Name',
    TEL: 'TEL',
    TEL1: 'TEL',
    'E-Mail': 'E-Mail',
    Postal_Code: 'Postal Code*',
    Suburb: 'Suburb',
    City: 'City',
    Consignee_Address: "Consignee's Address",
    notice_1: 'Physical address - Street name & number. Do not fill in any PO Box',
    Consignee_Address2: "Consignee's Address2",
    notice_2:
      'The description of the receiving address can further describe the receiving address 1, such as orientation, characteristics, etc. it is not necessary',
    Shipper_Info: "Shipper's Info",
    Common_Info: 'Frequent Contact',
    Shipper_Name: "Shipper's Name",
    Company: 'Company',
    Company_CN_Name: 'Company CN Name',
    Social_Credit_Code: 'Social Credit Code',
    Shipper_Address: "Shipper's Address",
    notice_3: "Please fill in shipper's address in English",
    'Shipper_Address(CN)': "Shipper's Address(CN)",
    notice_4: "Please fill in shipper's address in Chinese",
    Pakage_Description: 'Pakage Description',
    Box: 'Box',
    Chinese_Description: 'Chinese Description',
    Description: 'Description',
    Quantity: 'Quantity',
    'declaredvalue(USD)': 'declaredvalue(USD)',
    'Magnet/Battery': 'Magnet/Battery',
    Action: 'Action',
    NO: 'NO',
    YES: 'YES',
    Estimate_Weight: 'Estimate Weight',
    notice_5: 'weight, unit kg',
    Add_item: 'Add Item',
    Add_box: 'Add Box',
    Precautions: 'Precautions',
    notice_6:
      '1. There may be other charges such as customs duties, remote surcharges, special handling fees, etc.Depending on the type of deposit, it is possible to generate customs duties in the customs',
    notice_7:
      '2. In South Africa, there is no deliver on weekends and holidays. The specific delivery time limit is subject to the destination zip code.In remote areas, flight delays, customs clearance, etc., the time aging will increase.',
    notice_8: '3. Customer service: 400-921-9066 or Email: service@bufflogistics.com.',
    notice_9: 'I have confirmed reading and agreeing',
    notice_10: '《BUFFALO EXPRESS TERMS AND CONDITIONS OF CARRIAGE》',
    dialog_title: 'Buffalo EXPRESS TERMS AND CONDITIONS OF CARRIAGE',
    title1: 'IMPORTANT NOTICE',
    p1: 'When ordering Buffalo’s services you, as “Shipper”, are agreeing, on your behalf and on behalf of the receiver of the Shipment (“Receiver”) and anyone else with an interest in the Shipment that these Terms and Conditions shall apply. “Shipment” means all documents or parcels that travel under one waybill and which may be carried by any means Buffalo chooses, including air, road or any other carrier. A “waybill” shall include any Shipment identifier or document produced by Buffalo or Shipper automated systems such as a label, barcode, waybill or consignment note as well as any electronic version thereof. Every Shipment is transported on a limited liability basis as provided herein. If Shipper requires greater protection, then insurance may be arranged at an additional cost. (Please see below for further information). “Buffalo” means any member of the Buffalo Express Network.',
    title2: '1. Customs Clearance',
    p2: 'Buffalo may perform any of the following activities on Shipper’s or Receiver’s behalf in order to provide its services： （1）complete any documents, amend product or service codes, and pay any duties, taxes or penalties required under applicable laws and regulations (“Customs Duties”),Please try to fill accurate declear value, if fined by customs because of under-invoicing, the Shipper will afford panelty. （2） act as Shipper’s forwarding agent for customs and export control purposes and as Receiver solely for the purpose of designating a customs broker to perform customs clearance and entry and （3）redirect the Shipment to Receiver’s customs broker or other address upon request by any person who Buffalo believes in its reasonable opinion to be authorized.',
    title3: '2.Unacceptable Shipments',
    p3_1: '<p>A Shipment is deemed unacceptable if:</p>',
    p3_2: '<p>• no customs declaration is made when required by applicable customs regulations,</p>',
    p3_3: '<p>• it contains counterfeit goods, animals, bullion, currency, gem stones; weapons, explosives and ammunition; human remains; illegal items, such as ivory and narcotics,</p>',
    p3_4: '<p>• it is classified as hazardous material, dangerous goods, prohibited or restricted articles by IATA (International Air Transport Association), ICAO (International Civil Aviation Organization), ADR (European Road Transport Regulation on dangerous goods) or other relevant organization (“Dangerous Goods”),</p>',
    p3_5: '<p>• its address is incorrect or not properly marked or its packaging is defective or inadequate to ensure safe transportation with ordinary care in handling,</p>',
    p3_6: '<p>it contains any other item which Buffalo decides cannot be carried safely or legally.</p>',
    title4: '3. Deliveries and Undeliverables',
    p4_1: 'Shipments cannot be delivered to PO boxes or postal codes. Shipments are delivered to the Receiver’s address given by Shipper but not necessarily to the named Receiver personally. Shipments to addresses with a central receiving area will be delivered to that area. Buffalo may notify Receiver of an upcoming delivery or a missed delivery. Receiver may be offered alternative delivery options such as delivery on another day, no signature required, redirection or collection at a Buffalo Service Point. Shipper may exclude some delivery options on request.',
    p4_2: 'If the Shipment is deemed to be unacceptable as described in Section 2, or it has been undervalued for customs purposes, or Receiver cannot be reasonably identified or located, or Receiver refuses delivery or to pay Customs Duties or other Shipment charges, Buffalo shall use reasonable efforts to return the Shipment to Shipper at Shipper’s cost, failing which the Shipment may be released, disposed of or sold without incurring any liability whatsoever to Shipper or anyone else, with the proceeds applied against Customs Duties, Shipment charges and related administrative costs with the balance of the proceeds of a sale to be returned to Shipper. Buffalo shall have the right to destroy any Shipment which any law prevents Buffalo from returning to Shipper as well as any Shipment of Dangerous Goods.',
    p4_3: 'If the Shipment is deemed to be unacceptable as described in Section 2, or it has been undervalued for customs purposes, or Receiver cannot be reasonably identified or located, or Receiver refuses delivery or to pay Customs Duties or other Shipment charges, Buffalo shall use reasonable efforts to return the Shipment to Shipper at Shipper’s cost, failing which the Shipment may be released, disposed of or sold without incurring any liability whatsoever to Shipper or anyone else, with the proceeds applied against Customs Duties, Shipment charges and related administrative costs with the balance of the proceeds of a sale to be returned to Shipper. Buffalo shall have the right to destroy any Shipment which any law prevents Buffalo from returning to Shipper as well as any Shipment of Dangerous Goods.',
    title5: '4. Inspection',
    p5: 'Buffalo has the right to open and inspect a Shipment without notice for safety, security, customs or other regulatory reasons.',
    title6: '5. Shipment Charges and Fees',
    p6_1: 'Buffalo’s Shipment charges are calculated according to the higher of actual or volumetric weight per piece and any piece may be re-weighed and re-measured by Buffalo to confirm this calculation.',
    p6_2: 'Shipper, or the Receiver when Buffalo acts on Receiver’s behalf, shall pay or reimburse Buffalo for all Shipment or other charges due, or Customs Duties owed for services provided by Buffalo or incurred by Buffalo on Shipper’s or Receiver’s behalf. Payment of Customs Duties may be requested prior to delivery.',
    p6_3: 'If Buffalo uses its credit with the Customs Authorities or advances any Customs Duties on behalf of a Receiver who does not have an account with Buffalo, Buffalo shall be entitled to assess a fee.',
    title7: '6. Buffalo’s Liability',
    p7_1: '6.1 Buffalo’s liability in respect of any one Shipment transported by air (including ancillary road transport or stops en route) is limited by the Montreal Convention or the Warsaw Convention as applicable, or in the absence of such Convention, to the lower of (i) the current market or declared value, or (ii) 19 Special Drawing Rights per kilogram (approximately $US 26.00 per kilogram). Such limits shall also apply to all other forms of transportation, except where Shipments are carried only by road, when the limits below apply.',
    p7_2: 'For cross border Shipments transported by road, Buffalo’s liability is or shall be deemed to be limited by the Convention for the International Carriage of Goods by Road (CMR) to the lower of (i) current market value or declared value, or (ii) 8.33 Special Drawing Rights per kilogram (approximately $US 14.00 per kilogram). Such limits will also apply to national road transportation in the absence of any mandatory or lower liability limits in the applicable national transport law.',
    p7_3: 'If Shipper regards these limits as insufficient it must make a special declaration of value and request insurance as described in Section 8 or make its own insurance arrangements.',
    p7_4: 'Buffalo’s liability is strictly limited to direct loss and damage to a Shipment only and to the per kilogram limits in this Section 6. All other types of loss or damage are excluded (including but not limited to lost profits, income, interest, future business), whether such loss or damage is special or indirect, and even if the risk of such loss or damage was brought to Buffalo’s attention.',
    p7_5: '6.2 Buffalo will make every reasonable effort to deliver the Shipment according to Buffalo’s regular delivery schedules, but these schedules are not binding and do not form part of the contract. Buffalo is not liable for any damages or loss caused by delay, but for certain Shipments, Shipper may be able to claim limited delay compensation under the Money Back Guarantee terms and conditions.。',
    title8: '7.Claims',
    p8: 'All claims must be submitted in writing to Buffalo within thirty (30) days from the date that Buffalo accepted the Shipment, failing which Buffalo shall have no liability whatsoever. Claims are limited to one claim per Shipment, settlement of which will be full and final settlement for all loss or damage in connection therewith.',
    title9: '8. Shipment Insurance',
    p9: 'Buffalo may be able to arrange insurance covering the value in respect of loss of or damage to the Shipment, provided that the Shipper so instructs Buffalo in writing, including by completing the insurance section on the front of the waybill or by Buffalo’s automated systems and pays the applicable premium. Shipment insurance does not cover indirect loss or damage, or loss or damage caused by delays.',
    title10: '9.Circumstances Beyond Buffalo’s Control',
    p10: 'Buffalo is not liable for any loss or damage arising out of circumstances beyond Buffalo’s control. These include but are not limited to electrical or magnetic damage to, or erasure of, electronic or photographic images, data or recordings; any defect or characteristic related to the nature of the Shipment, even if known to Buffalo; any act or omission by a person not employed or contracted by Buffalo - e.g. Shipper, Receiver, third party, customs or other government official; “Force Majeure” - e.g. earthquake, cyclone, storm, flood, fog, war, plane crash, embargo, riot, civil commotion, or industrial action.',
    title11: '10. Shipper’s Warranties and Indemnities',
    p11_1:
      'Shipper shall indemnify and hold Buffalo harmless for any loss or damage arising out of Shipper’s failure to comply with the following warranties and representations：',
    p11_2: '• all information provided by Shipper or its representatives is complete and accurate;',
    p11_3: '• the Shipment is acceptable for transport under Section 2 above;',
    p11_4:
      '• the Shipment was prepared in secure premises by reliable persons and was protected against unauthorized interference during preparation, storage and any transportation to Buffalo;',
    p11_5:
      '• Shipper has complied with all applicable customs, import, export, data protection laws, sanctions, embargos and other laws and regulations; and',
    p11_6:
      '• Shipper has obtained all necessary consents in relation to personal data provided to Buffalo including Receiver’s data as may be required for transport, customs clearance and delivery, such as e-mail address and mobile phone number.',
    title12: '11. Routing',
    p12: 'Shipper agrees to all routing and diversion, including the possibility that the Shipment may be carried via intermediate stopping places.',
    title13: '12. Governing Law',
    p13: 'Any dispute arising under or in any way connected with these Terms and Conditions shall be subject, for the benefit of Buffalo, to the non-exclusive jurisdiction of the courts of, and governed by the law of the country of origin of the Shipment and Shipper irrevocably submits to such jurisdiction, unless contrary to applicable law.',
    title14: '13.Severability',
    p14: 'The invalidity or unenforceability of any provision shall not affect any other part of these Terms and Conditions.',
    date: 'Aug 13, 2018',
    close: 'close',
    Order: 'Order',
    notice_11: 'The express tracking number from your supplier',
    send: 'contact',
    receive: 'contact',
    contact_name: 'Name',
    contact_company: 'Company',
    contact_tel: 'Tel',
    contact_address: 'Address'
  },
  orderList: {
    balance: 'Balance',
    creditline: 'Credit Line',
    fee: 'Waiting Inbound(Tax+Freight Charge)',
    Minimun: 'Minimun Recharge',
    Suggest: 'Suggest Recharge'
  },
  orderBulk: {
    explain:
      'Dear BUFFALO Customer，South African Customs regulations require you to provide\nthe Invoice for International Orders.Please Upload Invoice for these orders Otherwise can’t create Orders.',
    tips: 'Please ensure that the balance is sufficient, otherwise it may affect warehouse shipments',
    currentlyAvailableCredit: 'Currently available credit',
    currentBalance: 'Current balance',
    totalEstimatedCost: 'Total estimated cost of waybill',
    OrderedSuccess: 'Successfully Ordered!',
    Dispatch_Selflifting: 'Dispatch / Self lifting',
    title_1: 'Import order',
    title_2: 'Order Information',
    label_type: 'Logistics Type',
    large_cargo: 'Large cargo category',
    label_Tax: 'Tax Bearer',
    receiver: 'receiver',
    sender: 'sender',
    label_Warehouse: 'Transshipment Warehouse',
    label_Currency: 'Reporting Currency',
    No_Data: 'No Data',
    import: 'import File',
    download: 'Download Temp',
    list_Fail: 'List of Failures',
    NOtice_1: 'Note: Wrong data will result in the whole file',
    NOtice_2: 'Failed to import all waybills,',
    NOtice_3: 'Please check and import again',
    Line_No: 'Line No',
    Error_reason: 'Error reason',
    Notice_4: 'Tips: Call +27 105934710 or Email service@bufflogistics.com for help.',
    list: 'Error info'
  },
  taxIndex: {
    title_1: 'Receiver Tax Unpaid',
    title_2: 'Orders ',
    All: 'All',
    label_1: 'Period of Cleared',
    value_1: 'All',
    value_2: '1~3 days',
    value_3: '3~7 days',
    value_4: 'Over 7 days',
    Consignee: 'Consignee',
    Tel: 'Consignee Tel',
    Order_No: 'Order No',
    Notified_Times: 'Notified Times',
    more: '3 more',
    search: 'search',
    export: 'export',
    Times_Notified: 'Times Notified',
    Processing_Record: 'Processing Record',
    Cleared_Time: 'Cleared Time',
    Destination: 'Destination',
    Parcel_Description: 'Parcel Description',
    Total_Values: 'Total Values',
    'Total_Amount(zar)': 'Total Amount(USD/ZAR)'
  },
  price: {
    logisticsType: 'Logistics type',
    Transfer_warehouse: 'Transfer warehouse',
    Zone_Code: 'Zone',
    title_1: 'Price List',
    title_2: 'Orders ',
    Freight: 'Freight',
    Overseas_warehouse: 'Overseas warehouse',
    description_download: 'Delivery area number description download',
    description_costs: 'Bunker Adjustment Factor',
    Weight_Section: 'Weight Section(KG)',
    First_Unit_Weight: 'First Unit Weight(KG)',
    First_Unit_Price: 'First Unit Price',
    Additional_Unit_Weight: 'Additional Unit Weight(KG)',
    Additional_Unit_Price: 'Additional Unit Price',
    Discount: 'Discount(%)',
    Update_Time: 'Update Time',
    Action: 'Action'
  },
  taxpayexpress: {
    Pay_Tax: 'Pay Tax',
    title_1: 'Pay Tax',
    title_2: 'Orders ',
    Order_NO: 'Order No',
    Pay_status: 'Pay status',
    status: 'Order Status',
    Cleared_Time: 'Cleared Time',
    Confirm_status: 'Confirmation Status',
    Order_no: 'Order No',
    Sign_Time: 'Sign Time',
    Sender: 'Sender',
    'Total_Amount(zar)': 'Total Amount(ZAR)',
    Action: 'Action'
  },
  remoteareaorder: {
    Create_Time: 'Create Time',
    title_1: 'Remote Area Orders',
    title_2: 'Orders',
    status_1: 'all status',
    status_2: 'Unconfirmed',
    status_3: 'Confirmed',
    Order_NO: 'Order NO',
    search: 'Search',
    export: 'Export',
    Action: 'Action',
    Time: 'Time',
    Confirmation_Status: 'Confirmation Status',
    Order_Status: 'Order Status',
    City: 'City',
    Post_Code: 'Post Code',
    Suburb: 'Suburb',
    'Consignee/Tel': 'Consignee/Tel'
  },
  freightstatistics: {
    detail: 'Detail',
    title_1: 'Cost Stats',
    title_2: 'Finacial Stats ',
    search: 'search',
    export: 'export',
    label_1: 'Orders Count',
    label_2: 'Total Final Weight(KG)',
    label_3: 'Total Freight Charge',
    label_4: 'Total Tax',
    label_5: 'Total Amount',
    Date: 'Create Date',
    Time: 'Time',
    Order_No: 'Order No',
    Customer_No: 'Reference',
    Status: 'Status',
    Boxs: 'Boxs',
    City: 'City',
    Postcode: 'Postcode',
    Suburb: 'Suburb',
    Area: 'Area',
    Final_Weight: 'Final Weight(KG)',
    Freight_Charge: 'Total Freight Charge',
    Tax: 'Total Tax',
    Amount: 'Total Amount',
    Action: 'Action',
    Price: 'Price',
    Freight_Charge1: 'Freight Charge',
    Operation_Fe_: 'Operation Fee',
    Magnet_Battery_Fee_: 'Magnet/Battery Fee'
  },
  user_info: {
    no_recharge: 'Recharge not Confirmed',
    date: 'Date',
    save: 'save',
    cancel: 'Cancel',
    ok: 'Ok',
    title_1: 'My Profile',
    title_2: 'Personal Info ',
    tab_1: 'My Profile',
    tab_2: 'Importers Info',
    shipper_Info: 'Supplier Info',
    shipper_Info_describe:
      'This shipper information will be used for your waybill customs clearance and invoice header. Please fill it out carefully. If you have any questions, please contact customer service.',
    label_1: 'name',
    label_2: 'Username',
    label_3: 'Email',
    label_4: 'Telphone',
    label_5: 'Company name',
    label_6: 'Short Company name',
    label_7: 'back address',
    label_8: 'Creditline',
    label_9: 'Balance',
    label_10: 'Name',
    label_11: 'ID',
    label_12: 'Importers Code',
    label_13: 'Address',
    label_14: 'Cellphone',
    edit: 'Update',
    editEmail: 'Edit email',
    editPhone: 'Edit phone',
    userChargeTip: 'There is an unconfirmed top-up order on your current account date',
    sendPin: 'Send Pin',
    code: 'Pin',
    getCode: 'Obtain',
    newPhone: 'New cellphone',
    upateSuccess: 'update successful!',
    curPhone: 'Phone',
    curEmail: 'Email',
    lessThan50Chars: 'Please enter no more than 50 letters',
    need13Digitals: 'Please enter 13 digits',
    need6_8Digitals: 'Please enter 6~8 digits',
    lessThan400Chars: 'Please enter no more than 400 letters',
    canotSupportFile: 'The file format is not supported',
    max5Files: 'Upload a maximum of 5 files',
    moreThan0: 'Please enter a number greater than 0',
    uploadProff: 'Please upload proof of payment'
  },
  changepwd: {
    title_1: 'Change Pwd',
    title_2: 'Personal Info',
    label_1: 'Original Password :',
    label_2: 'New Password :',
    label_3: 'Confirm Password :',
    label_4: 'Original Password(require)',
    label_5: 'New Password(require)',
    label_6: 'Confirm Password(require)',
    save: 'Save',
    verify_type: 'Verify Type :',
    pwd_verify: 'Verify with original pwd',
    yzm_verify: 'Verify with pin',
    telephone: 'Telephone',
    code: 'Code',
    get_code: 'Obtain',
    getCodeFirst: 'Please get a verification code',
    verification_code: 'Please enter a verification code',
    go_to_profile: 'Go to Profile',
    no_bind_telephone: 'Please connect with your telephone'
  },
  invoiceOrderIndex: {
    title_1: 'List of Invoices',
    title_2: 'Invoice management ',
    label_1: 'Awaiting Invoicing',
    label_2: 'Invoiced',
    Type: 'Status',
    Date_Created: 'Date Created',
    Invoice_amount: 'Invoice Amount',
    Tax: 'Tax',
    Invoice_Shipping_Address: 'Invoice Shipping Address',
    Invoice_Contact: 'Invoice Contact',
    all: 'All',
    payTax: 'Pay',
    unPay: 'Wait for payment    ',
    toBeInvoiced: '待开票',
    Operate: 'Action'
  },
  orderDetail: {
    problemInfo: 'Problem Information',
    costTip:
      'The specific amount of the return courier fee is subject to the actualchargeofthethird - party courier company',
    refundTip:
      "If canceling order before CN Warehouse outbound, the freight will befullyreturnedbacktocustomer's balance or the amount will turn 0 in generated bill. If the bill hasbeenchecked, theequalamountwill be taken out from next - termbill.",
    refundAmount: 'Refund Amount',
    destroyTip: 'Attention!Plz be informed that operation to destroy the package is irrevocable.',
    destroy: 'Destroy',
    returnGoods: 'Return Goods',
    orderState: 'Order State',
    cancelOrder1: 'Cancel Order',
    saveChanges: 'Save Changes',
    change: 'Change',
    applyModification: 'Apply Modification',
    placeholder: 'please choose',
    cancel: 'Cancel',
    confirm: 'Ok',
    pleaseInput: 'Please input',
    cancelOrder: 'Cancel',
    receiver: 'receiver',
    sender: 'sender',
    Detail_Name1: 'Basic Infomation',
    Detail_Name2: 'Receiver Infomation',
    Detail_Name3: 'Sender Infomation',
    Detail_Name4: 'Charging Information',
    Detail_Name5: 'Detail Information',
    Detail_Name6: 'Tracking Information',
    Order_No: 'Order No',
    Order_Time: 'Order Time',
    'B/L_No': 'B/L No',
    Freight_Charge_Status: 'Freight Charge Status',
    Order_Status: 'Order Status',
    Customer_No: 'Customer No',
    Last_Update: 'Last Update',
    Tax_Burden: 'Tax Payer',
    Tax_Status: 'Tax Status',
    MagnetBattery: 'Magnet/Battery',
    Clearance_Status: 'Clearance Status',
    'Deliver/Self-Collect': 'Deliver/Self-Collect',
    Collection_PIN: 'Collection PIN',
    Logistics: 'Logistics Type',
    Actual_Weight: 'Actual Weight/Weight by Volume',
    Final_Weight: 'Final Weight/Freight Charge',
    BAF: 'BAF',
    Operation_Fee: 'Operation Fee',
    'Magnet/Battery_Fee': 'Magnet/Battery',
    Total_Freight_Charge: 'Total Freight Charge',
    Estimated_Weight: 'Estimated Weight/Estimated Cost',
    Chg_Tax: 'Chg Tax',
    Tax_Paid: 'Tax Paid',
    COD: 'COD',
    Extra_Clearance_Fee: 'Extra Clearance Fee',
    Extra_Logistics_Fee: 'Extra Logistics Fee',
    Box_No: 'Box No',
    Estimated_W: 'Estimated Weight',
    Actual_W: 'Actual Weight',
    Weight_by_Volume: 'Weight by Volume',
    'L*W*H': 'L*W*H',
    Chinese_Description: 'Chinese Description',
    EN_Description: 'Name',
    Description: 'Description',
    HSCode: 'HSCode',
    Numbers: 'Numbers',
    Declare_Value: 'Declare Value',
    Company: 'Company',
    Receiver: 'Receiver',
    Receiver_Telephone: 'Telephone',
    Address: 'Address',
    Address2: 'Address2',
    City_Town: 'City/Town',
    Postcode_Suburb: 'Postcode',
    Email: 'Email',
    Area: 'Area',
    Transit_depo: 'Transit Depo',
    Company_CN: 'Company CN',
    Company_EN: 'Company EN',
    Sender: 'Sender',
    Telephone: 'Telephone',
    Sender_city: 'Sender City',
    Sender_Address: 'Sender Address',
    'Sender_Address(CN)': 'Sender Address(CN)',
    'PostCode/Suburb': 'PostCode/Suburb',
    Sender_Area: 'Area'
  },
  recharge: {
    text: 'We will confirm the transaction within one day and recharge the amount to your balance, also will inform you by e-mail.',
    uploadSuccess: 'Upload success',
    uploadFailed: 'Upload failed',
    rechargeText: 'Recharge',
    rechargeSuccess: 'recharged successfully',
    rechargeFail: 'recharged failure',
    serviceFee: 'Surcharge',
    submit: 'Submit',
    uploadProff: 'Please upload proof of payment'
  }
}
